<template>
  <div
    :class="[
      $style.adcStockRadio,
      {
        [$style.adcStockRadioDisabled]: disabled,
        [$style.adcStockRadioInput]: !nonInput,
      }
    ]"
  >
    <component :is="nonInput ? 'div' : 'fieldset'" :disabled="disabled" class="awFieldsetContents">
      <component :is="nonInput ? 'div' : 'legend'" class="awSrOnlyAbs">
        {{ $awt('awd.common.stock.stock') }}
      </component>
      <component
        :is="nonInput ? 'div' : 'label'"
        v-for="(stock, stockType) in stocks"
        :key="stockType"
        :title="$awt(stock.token)"
        :class="[
          'awHiddenInputFullSizeParent',
          $style.item,
          {
            [$style.itemSelected]: modelValue === stockType,
          },
        ]"
      >
        <input
          v-if="!nonInput"
          type="radio"
          :name="uuid"
          :value="stockType"
          :checked="modelValue === stockType"
          :class="['awHiddenInputFullSizeInput', $style.input]"
          @change="onChange(stockType)"
        >
        <lv-icon
          :name="stock.icon.name"
          :size="24"
          fill
          :class="$style.stockIcon"
        />
        <span>
          ({{ stock.stock }}{{ $awt('aw.global.quantity.piece') }})
          <span class="awSrOnlyAbs" v-text="$awt(stock.token)" />
        </span>
      </component>
    </component>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index.mjs';
  import basketControlMixin from '~~/common/components/Page/Common/BasketControl/basketControlMixin.js';
  import { uuid4 } from '~~/common/utils';

  export default {
    name: 'AdcStockRadio',
    components: { LvIcon },
    mixins: [basketControlMixin],
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      nonInput: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['update:modelValue'],
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        uuid: null,
      };
    },
    mounted () {
      this.uuid = uuid4();
    },
    methods: {
      onChange (stockType) {
        this.$emit('update:modelValue', stockType);
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.adcStockRadio {
  font-size: 12px;
  font-weight: 900;
  line-height: 16px;
  display: flex;
  flex-wrap: wrap;
  padding: 4px;
  border: 1px solid $color-border;
  border-radius: 8px;
  background: $color-white;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: 50%;
  flex-grow: 1;
  gap: 4px;
  padding: 3px 4px 3px 8px;
  border-radius: 8px;
}

.stockIcon {
  color: $color-black;
}

.input {
  border-radius: inherit;

  &:focus-visible {
    border: 1px solid currentColor;
  }
}

.adcStockRadioDisabled {
  cursor: not-allowed;
  opacity: 0.5;

  .input {
    cursor: not-allowed;
  }
}

.adcStockRadioInput {
  .itemSelected {
    background: $color-background-1;
  }
}
</style>
